import { Component } from "../component"
import Swiper from "swiper"
import { iterable } from "../helpers/iterable"

export class SectionEditor extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      expanded: "-expanded",
    }
  }

  ui() {
    return {
      textWImageBlock: ".section-editor-text-w-image",
      images: ".slider-image-on-mobile",
      toggleButtons: ".section-editor-toggle-button",
    }
  }

  reorderContent() {
    const { textWImageBlock, images } = this.$ui
    const swiper = document.createElement("div")
    const imagesWrapper = document.createElement("div")

    if (!images || !this.$el.dataset.imagesInCarousel) {
      return
    }

    iterable(images).forEach((item) => {
      const img = item.querySelector("img")
      const height = window.innerWidth * 0.75
      const width = height * img.dataset.aspectRatio

      item.style.width = `${width}px`
      item.style.minWidth = `${width}px`
      item.classList.add("swiper-slide")
      imagesWrapper.appendChild(item)
    })

    swiper.classList.add(
      "section-editor-block",
      "section-editor-swiper",
      "swiper"
    )
    imagesWrapper.classList.add("swiper-wrapper")
    swiper.appendChild(imagesWrapper)
    if (textWImageBlock[0].nextElementSibling) {
      this.$el.insertBefore(swiper, textWImageBlock[0].nextElementSibling)
    } else {
      this.$el.appendChild(swiper)
    }
  }

  initSwiper() {
    const { images } = this.$ui
    const swiperContainer = this.$el.querySelector(".swiper")

    if (!images) {
      return
    }

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 20,
    })
  }

  attachEvents() {
    const { toggleButtons } = this.$ui

    iterable(toggleButtons).forEach((button) => {
      button.addEventListener("click", () => {
        this.toggleContent()
      })
    })
  }

  toggleContent() {
    const { expanded } = this.dynamicClasses
    this.$el.parentElement.classList.toggle(expanded)
  }

  created() {
    if (window.innerWidth < 768) {
      this.reorderContent()
      this.initSwiper()
      this.attachEvents()
    }
  }
}
